import React, { Component } from 'react';
import { Col, FormGroup, Row } from 'reactstrap';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates';
import HtmlHelpers from '../../HtmlHelpers';
const moment = require('moment');
export default class WmDateField extends Component {
  constructor(props) {
    super(props);
    this.getDateField = () => /*#__PURE__*/React.createElement(Col, {
      md: this.props.fieldColumns,
      className: "text-left"
    }, /*#__PURE__*/React.createElement(SingleDatePicker, {
      ref: this.dateRef,
      id: this.props.name,
      date: this.dateValue(),
      onDateChange: this.dateChange,
      readOnly: this.props.readOnly,
      required: this.props.isRequired,
      focused: this.state.focused,
      onFocusChange: _ref => {
        let {
          focused
        } = _ref;
        return this.setState({
          focused
        });
      },
      small: true,
      isOutsideRange: day => this.checkDate(day),
      firstDayOfWeek: 1,
      displayFormat: "DD/MM/YYYY"
    }), /*#__PURE__*/React.createElement("div", {
      className: "invalid-feedback"
    }));
    this.checkDate = day => day === '';
    this.dateValue = () => this.props.value === '' ? null : moment(this.props.value, 'DD/MM/YYYY');
    this.dateChange = selected => {
      const value = {
        target: {
          name: this.props.name,
          value: selected ? selected.format('DD/MM/YYYY') : null
        }
      };
      this.props.onChange(value);
    };
    this.initialState = {
      focused: false
    };
    this.state = this.initialState;
    this.dateRef = React.createRef();
  }
  render() {
    return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Row, null, HtmlHelpers.getWmLabel(this.props), this.getDateField()));
  }
}
WmDateField.defaultProps = {
  isRequired: true,
  value: null
};